export default "__VITE_PUBLIC_ASSET__a293db23__"